import { createSlice } from "@reduxjs/toolkit";

interface PeopleState {
}

const initialState: PeopleState = {
};


const peopleSlice = createSlice({
  name: "people/slice",
  initialState,

  reducers: {
  },
});

export const {
} = peopleSlice.actions;

export default peopleSlice.reducer;
